/**
 * Русское склонение по числу: одна реализация на приложение.
 *
 * Формы передаются вызывающим, потому что регистр и слово у каждого места
 * свои («НАЧАТЬ · 3 ИГРОКА» под кнопкой и «3 игрока» в строке истории), а
 * правило выбора формы — одно и то же.
 */
export function plural(n: number, forms: [string, string, string]): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1];
  return forms[2];
}
